import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BBRestEndpointService} from '../@modules/bb-rest/bb-rest-endpoint.service';
import {LoanApplication} from '../@models/loan-application.model';
import {BBRestPagination} from '../@modules/bb-rest/bb-rest-pagination.service';

@Injectable()
export class LoanApplicationDBService {
  prefix = 'loan-applications';

  constructor(private api: BBRestEndpointService) {
  }

  get(loanApplicationId: number): Observable<LoanApplication.Model> {
    return this.api.run_detail('GET', this.prefix, loanApplicationId);
  }

  applyForLoan(vars: LoanApplication.CreateVars): Observable<LoanApplication.Model> {
    return this.api.run_list('POST', this.prefix, vars);
  }

  getPaginatedResults(pageLimit?: number): BBRestPagination<LoanApplication.Model> {
    return this.api.getPagination(this.prefix, pageLimit);
  }
}
